import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';

@Component({
  selector: 'app-select-products-modals',
  templateUrl: './select-products-modals.component.html',
  styleUrls: ['./select-products-modals.component.scss']
})
export class SelectProductsModalsComponent implements OnInit {

  searchControl = new FormControl('');
  filterBy = 'All';
  selectedVariants: Set<string> = new Set();
  maxVariants = 500;
  isLoading = false;
  products: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { existingProducts: any[] },
    private dialogRef: MatDialogRef<SelectProductsModalsComponent>,
    // Aquí inyectarás tu servicio de API
    // private apiService: YourApiService
    private lambdaService: LambdaService,
    private themingService: ThemingService
  ) {}

  ngOnInit(): void {
    // Pre-seleccionar productos que ya están en la orden
    this.data.existingProducts.forEach(p => {
      if (p.variant?.id) {
        this.selectedVariants.add(p.variant.id);
      }
    });

    // Cargar productos (aquí llamarás a tu API)
    //this.loadProducts();
    this.getProducts();
    // Búsqueda en tiempo real
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(query => this.getProducts());
  }

  async getProducts() {
    this.isLoading = true;
    await this.lambdaService
      .getProducts(
        this.themingService.shopId,
        0,
        300,
        this.searchControl.value || "",
        "",
        "DESC",
        ""
      )
      .then((data: any) => {
        this.products = data.products;
      });
    this.isLoading = false;
  }

  groupProducts(products: any[]): any[] {
    // Si tu API ya devuelve los productos agrupados, no necesitas esta función
    const groupsMap = new Map();

    products.forEach(p => {
      if (!groupsMap.has(p.productId || p.id)) {
        groupsMap.set(p.productId || p.id, {
          productId: p.productId || p.id,
          productName: p.productName,
          productImage: p.productImage,
          variants: [],
          expanded: true
        });
      }
      groupsMap.get(p.productId || p.id).variants.push(p);
    });

    return Array.from(groupsMap.values());
  }

  toggleGroup(group: any): void {
    group.expanded = !group.expanded;
  }

  toggleVariant(variant: any): void {
    if (this.selectedVariants.has(variant.itemId)) {
      this.selectedVariants.delete(variant.itemId);
    } else {
      if (this.selectedVariants.size >= this.maxVariants) {
        alert(`Máximo ${this.maxVariants} variantes permitidas`);
        return;
      }
      this.selectedVariants.add(variant.itemId);
    }
  }

  get selectedCount(): number {
    return this.selectedVariants.size;
  }

  isVariantSelected(variantId: string): boolean {
    return this.selectedVariants.has(variantId);
  }

  isGroupFullySelected(group: any): boolean {
    return group.variants.length > 0 &&
      group.variants.every((v: any) => this.selectedVariants.has(v.id));
  }

  toggleGroupSelection(group: any): void {
    const allSelected = this.isGroupFullySelected(group);
    
    group.variants.forEach((v: any) => {
      if (allSelected) {
        this.selectedVariants.delete(v.id);
      } else {
        if (this.selectedVariants.size < this.maxVariants) {
          this.selectedVariants.add(v.id);
        }
      }
    });
  }

  formatPrice(price: number): string {
    if (price === null || price === undefined) return '₡0.00';
    return `₡${price.toLocaleString('es-CR', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    })} CRC`;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    const selected: any[] = [];
    // console.log('Selected variants:', Array.from(this.selectedVariants));
    // console.log('Products to be checked:', this.products);
    this.products.forEach((product: any) => {
      // console.log("items", product.items);
      product.items?.forEach((item: any) => {
        if (item && this.selectedVariants.has(item.itemId)) {
          selected.push({
            productId: product.productId,
            productName: product.productName,
            productCode: product.productCode,
            imageURL: product.imageURL,
            ...item
          });
        }
      });
    });

    this.dialogRef.close(selected);
  }

}

